export enum ElmWorkflowType {
  Onboarding = 0,
  Change = 1,
  Offboarding = 2,
}
